'use client';

import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { useRouter } from '../../../hooks/router/useCustomRouter';
import { BottomActions } from '../../molecules/bottom-actions/BottomActions';
import { Goat } from '../../molecules/goat/Goat';

type NotFoundProps = {
	redirectUrl?: string;
};

export const NotFound = ({ redirectUrl }: NotFoundProps) => {
	const { $t } = useIntl();
	const { replace } = useRouter();

	return (
		<S.GoatWrapper>
			<Goat image="notFound" testID="notFound-page" withoutTitleContainer>
				<S.Wrapper>
					<S.Title>{$t('notFound.title')}</S.Title>
					<S.Info>{$t('notFound.description')}</S.Info>
					<BottomActions
						buttonPropsArray={[
							{
								onClick: () => {
									if (redirectUrl) {
										window.location.href = redirectUrl;
									} else {
										replace('/');
									}
								},
								testID: 'notFound-takeMeHome-button',
								text: $t('notFound.button')
							}
						]}
					/>
				</S.Wrapper>
			</Goat>
		</S.GoatWrapper>
	);
};

namespace S {
	export const GoatWrapper = styled.div`
		margin-top: ${({ theme }) => theme.spacings.large};
	`;

	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
	`;
	export const Title = styled.label`
		${({ theme }) => theme.fonts.headings.title5};
		margin: ${({ theme }) => `${theme.spacings.medium} 0 ${theme.spacings.xxsmall}`};
		padding: ${({ theme }) => `${theme.spacings.small} 0 ${theme.spacings.small}`};
	`;
	export const Info = styled.label`
		${({ theme }) => theme.fonts.text.text3};
		padding: 0 ${({ theme }) => theme.spacings.small};
		text-align: center;
	`;
}
